import { connect } from 'react-redux';

import {
    fetchResearchersPage,
    setSelectedTabIndex,
    setSelectedThemeSlug
} from 'client/ducks/researchers/actions';
import {
    getResearchersPage,
    hasMoreResearchers,
    isLoading,
    getResearchersTabs,
    getSelectedTabIndex,
    getSelectedThemeSlug
} from 'client/ducks/researchers/selectors';
import { State } from 'client/store';

import ResearchersPage, { DispatchProps, StateProps } from './researchers-list';
import { fetchThemes } from 'client/ducks/themes/actions';
import { getThemes } from 'client/ducks/themes/selectors';

function mapStateToProps(state: State): StateProps {
    return {
        ...getResearchersPage(state),
        themes: getThemes(state),
        hasMore: hasMoreResearchers(state),
        isLoading: isLoading(state),
        tabs: getResearchersTabs(state),
        selectedTabIndex: getSelectedTabIndex(state),
        selectedThemeSlug: getSelectedThemeSlug(state)
    };
}

const mapDispatchToProps = {
    fetchPage: fetchResearchersPage,
    fetchThemes,
    setTabIndex: setSelectedTabIndex,
    setThemeSlug: setSelectedThemeSlug

};

export default connect<StateProps, DispatchProps>(mapStateToProps, mapDispatchToProps)(ResearchersPage) as any;
